import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;
export const Badge = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -10px;
  right: -0px;
  background-color: red;
  border-radius: 50%;
  min-height: 20px;
  min-width: 20px;
  z-index: 999;
`;

export const BadgeText = styled.p`
  color: #fff;
  font-family: "Inter";
  font-size: 10px;
  line-height: 12px;
`;
